import defaultConfig from './config';

// local_gui.ps1 sets this only for the local server process. Production builds
// always use the normal config generated by the deployment script.
const config = process.env.NODE_ENV === 'development' && process.env.REACT_APP_DAVAX_LOCAL_CONFIG
  ? JSON.parse(process.env.REACT_APP_DAVAX_LOCAL_CONFIG)
  : defaultConfig;

export default config;
